if (!customElements.get('wishlist-proxy')) {
  class WishlistProxy extends HTMLElement {
    constructor() {
      super();
      this.stateObserver = null;
      this.domObserver = null;
      this.wishlistrBtn = null;
      this.handleBuyClick = this.handleBuyClick.bind(this);
      this.handleGalleryClick = this.handleGalleryClick.bind(this);
    }

    connectedCallback() {
      this.buyBtn = document.querySelector('.main-product__wishlist');
      this.galleryBtn = document.querySelector('.product-gallery__action-btn--wishlist');

      if (!this.connect()) {
        this.domObserver = new MutationObserver(() => {
          if (this.connect()) {
            this.domObserver.disconnect();
            this.domObserver = null;
          }
        });
        this.domObserver.observe(document.body, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.stateObserver) { this.stateObserver.disconnect(); this.stateObserver = null; }
      if (this.domObserver) { this.domObserver.disconnect(); this.domObserver = null; }
      if (this.buyBtn) this.buyBtn.removeEventListener('click', this.handleBuyClick);
      if (this.galleryBtn) this.galleryBtn.removeEventListener('click', this.handleGalleryClick);
    }

    connect() {
      this.wishlistrBtn = document.querySelector('.wishlist-button');
      if (!this.wishlistrBtn) return false;

      this.stateObserver = new MutationObserver(() => this.syncState());
      this.stateObserver.observe(this.wishlistrBtn, { attributes: true, attributeFilter: ['class'] });

      if (this.buyBtn) this.buyBtn.addEventListener('click', this.handleBuyClick);
      if (this.galleryBtn) this.galleryBtn.addEventListener('click', this.handleGalleryClick);

      this.syncState();
      return true;
    }

    syncState() {
      const isActive = this.wishlistrBtn.classList.contains('active');
      if (this.buyBtn) {
        this.buyBtn.classList.toggle('is-active', isActive);
        const label = this.buyBtn.querySelector('.main-product__wishlist-label');
        if (label) {
          label.textContent = isActive ? label.dataset.removeText : label.dataset.addText;
        }
      }
      if (this.galleryBtn) this.galleryBtn.classList.toggle('is-active', isActive);
    }

    handleBuyClick() { if (this.wishlistrBtn) this.wishlistrBtn.click(); }
    handleGalleryClick() { if (this.wishlistrBtn) this.wishlistrBtn.click(); }
  }

  customElements.define('wishlist-proxy', WishlistProxy);
}
